import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { HeaderModule } from "src/app/ui-widgets/header/header.module";
import { ProductFiltersModule } from "src/app/ui-widgets/product-filters/product-filters.module";
import { ProductPaginationModule } from "src/app/ui-widgets/product-pagination/product-pagination.module";
import { SidebarModule } from "src/app/ui-widgets/sidebar/sidebar.module";
import { BifocalProgressiveComponent } from "./bifocal-progressive/bifocal-progressive.component";
import { CoatingsComponent } from "./coatings/coatings.component";
import { LensAccessoriesComponent } from "./lens-accessories/lens-accessories.component";
import { LensPrescriptionComponent } from "./lens-prescription/lens-prescription.component";
import { LensReadersComponent } from "./lens-readers/lens-readers.component";
import { LensOptionsComponent } from "./lens-options/lens-options.component";
import { LensSelectionRoutingModule } from "./lens-selection-routing.module";
import { LensSelectionComponent } from "./lens-selection.component";
import { NonPrescriptionComponent } from "./non-prescription/non-prescription.component";
import { ProductDataComponent } from "./product-data/product-data.component";
import { ScratchComponent } from "./scratch/scratch.component";
import { SingleVisionComponent } from "./single-vision/single-vision.component";
import { TintsComponent } from "./tints/tints.component";
import { NgxUiLoaderModule } from "ngx-ui-loader";

@NgModule({
    imports: [
        RouterModule,
        ProductFiltersModule,
        CommonModule,
        HeaderModule,
        SidebarModule,
        ProductPaginationModule,
        LensSelectionRoutingModule,
        NgxUiLoaderModule
    ],
    declarations: [
        LensSelectionComponent,
        BifocalProgressiveComponent,
        CoatingsComponent,
        LensAccessoriesComponent,
        LensPrescriptionComponent,
        LensReadersComponent,
        LensOptionsComponent,
        NonPrescriptionComponent,
        ProductDataComponent,
        ScratchComponent,
        SingleVisionComponent,
        TintsComponent
    ],
    exports: [
        LensSelectionComponent,
        BifocalProgressiveComponent,
        CoatingsComponent,
        LensAccessoriesComponent,
        LensPrescriptionComponent,
        LensReadersComponent,
        LensOptionsComponent,
        NonPrescriptionComponent,
        ProductDataComponent,
        ScratchComponent,
        SingleVisionComponent,
        TintsComponent 
    ]
  })
  export class LensSelectionModule { }